/* global axios */
import ApiClient from '../ApiClient';

class CallApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getConversationCalls({ conversationId, page = 1, perPage = 100 }) {
    return axios.get(`${this.url}/${conversationId}/calls`, {
      params: { page, per_page: perPage },
    });
  }
}

export default new CallApi();
